// extracted by mini-css-extract-plugin
export default {"component":"CallToAction__component-wWQk","showOnMobile":"CallToAction__showOnMobile-zXeq","tagline":"CallToAction__tagline-UIg5","cta":"CallToAction__cta-bF2q"};